export const FEATURES_LIST = [{
  title: '汇集多方数据，破除数据孤岛',
  desc: '聚合多渠道碎片客户数据，统一整合沉淀，打造企业数字化高地',
  img: 'big-data/Gather1.jpg'
}, {
  title: '360°客户画像，赋能精细运营',
  desc: '多维度客户智能打标，输出立体客户画像，全生命周期管理，精细运营提升客户价值',
  img: 'big-data/operate36.jpg'
}, {
  title: '智能自动营销，降低人力成本',
  desc: '可视化创建营销流程，人工智能自动营销，有效释放企业运营人力',
  img: 'big-data/automatic1.jpg'
}, {
  title: '深度数据洞察，提升营销效果',
  desc: '客户数据、营销数据实时统计分析为营销决策提供有力数据支持',
  img: 'big-data/insight1.jpg'
}];
export const SKILL_LIST = [{
  img: 'Label.png',
  title: '标签系统',
  desc: '账户标签是整个股民标签体系中最重点的一部分，借助账户分析诊断的落地，相应的账户分析、诊断标签都能够通过标签系统进行很好的落地，为券商今后做好财富管理转型做前期的铺垫'
}, {
  img: 'behaviorAnalysis.png',
  title: '行为分析',
  desc: '行为分析系统支持统一用户身份识别功能，通过对用户行为监测获得的数据进行分析，可以让企业更加详细、清楚地了解用户的行为习惯，从而找出网站、推广、产品等企业营销环境存在的问题'
}, {
  img: 'Accountanalysis.png',
  title: '账户分析及诊断',
  desc: '账户分析诊断不仅能给用户提供可视化的账户视图，还可以给后台运营人员、投顾人员提供客观准确的账户画像，为后期推荐投顾资讯、策略、观点、产品、功能等账户营销动作做数据准备'
}, {
  img: 'recommendation.png',
  title: '智能推荐',
  desc: '基于用户标签和行为数据和建立精准的用户画像，为用户匹配个性化信息。包括基于用户的行为数据构建个性化的用户兴趣模型，确保资讯、push、营销广告推送的有效性及精准性'
}, {
  img: 'TagCloud.png',
  title: '标签云',
  desc: '同花顺云标签体系覆盖流量漏斗全路径。既提供了让产品运营人员“开箱即用”，促进业务增长的预定义标签，也支持适应业务发展变化的标签自定义和自动化生成工具，适用于产品推荐，产品诊断以及智能投顾等业务场景'
}];